/*
  c-team: mobile card stack (<768px). The top card (data-depth="0") is sent to the back
  on autoplay, tap, swipe, Enter/Space/ArrowRight. Autoplay pauses while the stack is
  off-screen, hovered, focused, or when the user prefers reduced motion.
*/
if (!customElements.get('c-team-stack')) {
  customElements.define(
    'c-team-stack',
    class CTeamStack extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.c-team__card'));
        if (this.cards.length < 2) return;

        this.mobile = window.matchMedia('(width < 768px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = parseInt(this.dataset.interval, 10) || 3000;
        this.inView = false;
        this.paused = false;
        this.busy = false;

        this.onMedia = () => this.sync();
        this.mobile.addEventListener('change', this.onMedia);
        this.reduced.addEventListener('change', this.onMedia);

        this.addEventListener('click', () => this.mobile.matches && this.next());
        this.addEventListener('keydown', (e) => {
          if (!this.mobile.matches) return;
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowRight') {
            e.preventDefault();
            this.next();
          }
        });
        this.addEventListener('pointerdown', (e) => (this.startX = e.clientX));
        this.addEventListener('pointerup', (e) => {
          if (this.startX == null || !this.mobile.matches) return;
          const dx = e.clientX - this.startX;
          this.startX = null;
          if (Math.abs(dx) > 40) {
            this.suppressClick = true;
            this.next();
          }
        });
        this.addEventListener(
          'click',
          (e) => {
            if (this.suppressClick) {
              this.suppressClick = false;
              e.stopImmediatePropagation();
            }
          },
          true
        );
        ['mouseenter', 'focusin'].forEach((t) => this.addEventListener(t, () => this.pause(true)));
        ['mouseleave', 'focusout'].forEach((t) => this.addEventListener(t, () => this.pause(false)));

        this.io = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        });
        this.io.observe(this);
        this.sync();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.io && this.io.disconnect();
        if (this.mobile) {
          this.mobile.removeEventListener('change', this.onMedia);
          this.reduced.removeEventListener('change', this.onMedia);
        }
      }

      sync() {
        const interactive = this.mobile.matches;
        if (interactive) {
          this.setAttribute('tabindex', '0');
          this.setAttribute('aria-roledescription', 'card stack');
        } else {
          this.removeAttribute('tabindex');
          this.removeAttribute('aria-roledescription');
        }
        clearInterval(this.timer);
        if (interactive && this.inView && !this.paused && !this.reduced.matches) {
          this.timer = setInterval(() => this.next(), this.interval);
        }
      }

      pause(state) {
        this.paused = state;
        this.sync();
      }

      next() {
        if (this.busy) return;
        const n = this.cards.length;
        const top = this.cards.find((c) => c.dataset.depth === '0');
        if (!top) return;
        const settle = () => {
          this.cards.forEach((c) => {
            c.dataset.depth = String((parseInt(c.dataset.depth, 10) - 1 + n) % n);
          });
          top.classList.remove('is-leaving');
          this.busy = false;
        };
        this.busy = true;
        if (this.reduced.matches) {
          settle();
          return;
        }
        top.classList.add('is-leaving');
        setTimeout(settle, 450);
      }
    }
  );
}
